import { WhatsAppInbox } from '@/features/whatsapp-inbox/whatsapp-inbox'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/company/$companyId/whatsapp/')({
	component: WhatsAppInbox,
})
